import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/cpjs_bg.png';
import _imports_1 from '@/assets/img/logo.png';
import _imports_2 from '@/assets/img/pic.png';
const _withScopeId = n => (_pushScopeId("data-v-007481dc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "banner"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));
const _hoisted_3 = {
  class: "company_jj"
};
const _hoisted_4 = {
  class: "jieshao"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logo"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}), /*#__PURE__*/_createElementVNode("h2", null, "抖抖音乐铃声")], -1));
const _hoisted_6 = {
  class: "pic"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text"
}, " APP简介：抖抖音乐铃声是一款专为个性化来电体验设计的轻量级APP，支持一键设置视频彩铃和音频彩铃。用户可从海量热门音乐、搞笑片段或自制内容中选择素材，快速打造专属来电秀，让通话等待时光更生动有趣。应用操作简单，适配主流运营商，实时更新潮流素材库，满足年轻人、商务人士等不同场景的个性化需求。 ", -1));
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"company_jj\" data-v-007481dc><div class=\"jieshao\" data-v-007481dc><div class=\"logo\" data-v-007481dc><h2 data-v-007481dc>产品<b data-v-007481dc>信息</b></h2></div><div class=\"content\" data-v-007481dc><img class=\"left\" src=\"" + _imports_1 + "\" alt=\"\" data-v-007481dc><div class=\"info\" data-v-007481dc><p data-v-007481dc> APP备案名称：抖抖音乐铃声 <br data-v-007481dc>APP备案号：蜀ICP备18001011号-3A <br data-v-007481dc>软件著作权登记号：2019SRE020577 <br data-v-007481dc>软件著作权证书号：软著登字第E0032891号 <br data-v-007481dc>著作权人：成都颂佳科技有限公司 </p><a href=\"https://dou-sucai.oss-cn-hangzhou.aliyuncs.com/ddyyls-wdj-0721.apk?OSSAccessKeyId=LTAI5tQxtzXyHx72YYgG6Sca&amp;Expires=1789170646&amp;Signature=j85FClS2ZFDFIXF1rDaAuZi6eT8%3D\" data-v-007481dc>立即下载</a></div><img src=\"" + _imports_2 + "\" alt=\"\" data-v-007481dc></div></div></div>", 1);
import { reactive, onMounted } from 'vue';
import Headers from "@/components/header/index.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const data = reactive({});
    onMounted(() => {});
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Headers, {
        class: "headers"
      }), _hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4], item => {
        return _createElementVNode("img", {
          key: item,
          src: require(`@/assets/img/${item}.jpg`),
          alt: ""
        }, null, 8, _hoisted_7);
      }), 64))]), _hoisted_8])]), _hoisted_9]);
    };
  }
});